// Utility functions for compatibility score colors

export const getScoreColor = (score: number): string => {
  if (score >= 90) return "text-emerald-600 dark:text-emerald-400"; // Perfect - Emerald (special!)
  if (score >= 80) return "text-green-600 dark:text-green-500"; // Great - Green
  if (score >= 70) return "text-green-500 dark:text-green-600"; // Good - Lighter Green
  if (score >= 60) return "text-yellow-600 dark:text-yellow-500"; // Possible - Yellow
  return "text-muted-foreground"; // Low - Muted
};

export const getScoreBadge = (score: number) => {
  if (score >= 90) return { text: "Perfect Match ✨", variant: "default" as const };
  if (score >= 80) return { text: "Great Match ⭐⭐⭐⭐", variant: "default" as const };
  if (score >= 70) return { text: "Good Match ⭐⭐⭐", variant: "secondary" as const };
  if (score >= 60) return { text: "Possible Match ⭐⭐", variant: "secondary" as const };
  return { text: "Low Compatibility ⭐", variant: "outline" as const };
};
